import React from 'react'

import { ArrowDown } from '../../assets/icons'

import { DistrictWrapper, } from './index.styles';

import { ISettlement, ISnp } from '../../interfaces/snp.interface';
import { getLang } from '../../utils/helpers.utils';

interface IProps {
  district: ISettlement;
  onClick: (item: any) => void;
}

const DistrictItem: React.FC<IProps> = ({ district, onClick }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleOpen = () => {
    setIsOpen(!isOpen)
  }

  return (
    <DistrictWrapper isOpen={isOpen} status={district.status}>
      <div className="district-name" onClick={() => onClick(district)} >
        {/* <ArrowDown /> */}
        <span>{district[`name${getLang()}`]}</span>
      </div>

      {/* {isOpen && district.children &&
        <div className='snps'>
          {
            district.children.map((snp) =>
              <div key={snp.kato} className={`snp-name`} onClick={() => onClick(snp)}>
                <SelectIcon height={10} />
                <SnpName status={snp.fillingStatus}>{snp[`name${getLang()}`]}</SnpName> 
                <Pen className='pen' height={10} />
              </div>
            )
          }
        </div>
      } */}
    </DistrictWrapper>
  )
}

export default DistrictItem